import { createRouter, createWebHistory } from 'vue-router'

import A11yAnnouncer from '@kidzonet/a11y-live-region-announcer'
import PrivacyUrl from '@kidzonet/dashboard-privacy-policy/src/route'
import TOSUrl from '@kidzonet/dashboard-tos/src/route'
import NotFoundRoute from '@kidzonet/error-404'
import { authGuardBeforeEachHook, setNextPageTitleHook } from '@kidzonet/vue3-navigation-guard'

import AuthenticatedUrls from './AuthenticatedUrls'
import LoginUrls from './LoginUrls'
import SupportUrls from './SupportUrls'

const router = createRouter({
    history: createWebHistory('/'),
    routes: [{
        path: '/',
        component: A11yAnnouncer,
        children: [
            ...LoginUrls,
            ...AuthenticatedUrls,
            PrivacyUrl,
            TOSUrl,
            ...SupportUrls,
            NotFoundRoute,
        ],
    }],
})

router.beforeEach(authGuardBeforeEachHook)
router.beforeEach(setNextPageTitleHook())

export default router
